import { render, staticRenderFns } from "./UserWarning.vue?vue&type=template&id=10b51c44&"
import script from "./UserWarning.vue?vue&type=script&lang=js&"
export * from "./UserWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports